import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Configuração do Favicon de Luxo
const setLuxuryFavicon = () => {
  const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
  link.type = 'image/svg+xml';
  link.rel = 'icon';
  link.href = '/favicon.svg';
  document.getElementsByTagName('head')[0].appendChild(link);
};
setLuxuryFavicon();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
